var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8214 3.05943C11.4893 2.45089 12.5107 2.45089 13.1786 3.05943L12.6735 3.61383L13.1786 3.05943L21.1786 10.3483L20.7055 10.8676L21.1786 10.3483C21.5426 10.6799 21.75 11.1495 21.75 11.6419V20.0002C21.75 20.9667 20.9665 21.7502 20 21.7502H16C15.0335 21.7502 14.25 20.9667 14.25 20.0002V16.0002C14.25 14.7576 13.2426 13.7502 12 13.7502C10.7574 13.7502 9.75 14.7576 9.75 16.0002V20.0002C9.75 20.9667 8.9665 21.7502 8 21.7502H4C3.0335 21.7502 2.25 20.9667 2.25 20.0002V11.6419C2.25 11.1495 2.45743 10.6799 2.82139 10.3483L10.8214 3.05943ZM12.1684 4.16823C12.073 4.08129 11.927 4.08129 11.8316 4.16823L11.3265 3.61383L11.8316 4.16823L3.83163 11.4571C3.77963 11.5045 3.75 11.5716 3.75 11.6419V20.0002C3.75 20.1383 3.86193 20.2502 4 20.2502H8C8.13807 20.2502 8.25 20.1383 8.25 20.0002V16.0002C8.25 13.9291 9.92893 12.2502 12 12.2502C14.0711 12.2502 15.75 13.9291 15.75 16.0002V20.0002C15.75 20.1383 15.8619 20.2502 16 20.2502H20C20.1381 20.2502 20.25 20.1383 20.25 20.0002V11.6419C20.25 11.5716 20.2204 11.5045 20.1684 11.4571L12.1684 4.16823L12.6684 3.61942L12.1684 4.16823Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1bbbf65e49a3c466e0279b5cb00a146d.svg";
export { ForwardRef as ReactComponent };